module.exports = __webpack_public_path__ + "static/media/OM_grey.124eefac.svg";